import nBossConnection from 'modules/base/service/nBossConnection';
import UserDto from 'app/admin/user/dto/UserDto';
import AccessConfigDto from 'app/admin/user/dto/AccessConfigDto';

class UserLoginService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'samlUserLogin';
	}

	/**
	* @return {Promise<boolean>}
	*/
	getLoginState() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getLoginState`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	* @param {string} email
	* @param {string} password
	* @return {Promise<boolean>}
	*/
	login(email, password) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/login`, {
					email,
					password
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	* @param {string} role
	* @return {Promise<boolean>}
	*/
	setRole(role) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/setRole`, { role })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	* @param {number} id
	* @return {Promise<boolean>}
	*/
	setUserGroupId(userGroupId) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/setUserGroupId`, { userGroupId })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new UserLoginService();